<template>
  <q-page>
    <q-table title="Group Orders"
             :columns="ordersColumns"
             :data="groupOrders" flat
             :pagination.sync="pagination"
             :filter="filter"
             binary-state-sort
              row-key="orderId" >
      <template v-slot:top>
        <q-space />
        <q-input dense debounce="300" color="primary" v-model="filter">
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>
      <template v-slot:body-cell-name="props">
        <q-td key="name" :props="props">
          <router-link :to="`/admin/group-orders/${props.row.id}`">{{props.row.name}}</router-link>
        </q-td>
      </template>
      <template v-slot:body-cell-actions="props">
        <q-td key="actions" :props="props">
          <q-btn dense flat icon="edit" size="sm" :to="`/admin/group-orders/${props.row.id}`"></q-btn>
          <q-btn dense flat icon="delete" size="sm" @click="deleteGroupOrder(props.row.id)"></q-btn>
        </q-td>
      </template>

      <template v-slot:bottom-row>
        <q-tr>
          <q-td colspan="100%">
            <q-btn dense flat icon="add" class="full-width" @click="addGroupOrder" label="New Group Order"/>
          </q-td>
        </q-tr>
      </template>
    </q-table>
  </q-page>
</template>

<script>
import moment from 'moment'
import gql from 'graphql-tag'
import adminNotifyError from '../../util/adminNotifyError'
import { formatDate } from '../../util/string'

export default {
  name: 'PageAdminGroupOrders',
  apollo: {
    groupOrders: {
      query: gql`query {
        groupOrders {
          id
          name
          openDate
          closeDate
          isOpen
        }
      }
      `,
      fetchPolicy: 'network-only'
    }
  },
  methods: {
    fromNow (t) {
      if (!t) return '-'
      return moment(t).fromNow()
    },
    formatDate (d) {
      if (!d) return '-'
      return moment(d).format('DD/MM/YY')
    },
    addGroupOrder () {
      this.$q.dialog({
        title: 'New Group Order',
        message: `Once you click 'ok' you'll be taken to a page to edit the new group order.`,
        cancel: { flat: true }
      }).onOk(async () => {
        try {
          let result = await this.$apollo.mutate({
            mutation: gql`
              mutation createGroupOrder ($input: GroupOrderInput) {
                createGroupOrder (input: $input ) {
                  id
                  name
                  openDate
                  closeDate
                  isOpen
              }
            }
            `,
            variables: {
              input: {
                name: 'New Group Order',
                openDate: new Date(),
                closeDate: new Date(),
                notes: ''
              }
            }
          })
          this.$router.push(`/admin/group-orders/${result.data.createGroupOrder.id}`)
        } catch (error) {
          adminNotifyError(this.$q, 'Failed to create group order.', error)
        }
      })
    },
    deleteGroupOrder (id) {
      this.$q.dialog({
        title: 'Delete Group Order',
        message: `Are you sure you want to delete this order?`,
        cancel: { flat: true }
      }).onOk(async () => {
        try {
          await this.$apollo.mutate({
            mutation: gql`
              mutation deleteGroupOrder ($id: ID!) {
                deleteGroupOrder ( id: $id ) {
                  id
                  name
                  openDate
                  closeDate
                  isOpen
              }
            }
            `,
            variables: {
              id
            }
          })
        } catch (error) {
          adminNotifyError(this.$q, 'Failed to delete group order.', error)
        }
      })
    }
  },
  data () {
    return {
      filter: '',
      ordersColumns: [
        { name: 'name', align: 'left', required: true, label: 'Name', field: 'name', sortable: true },
        { name: 'openDate', align: 'left', required: true, label: 'Open Date', field: 'openDate', sortable: true, format: formatDate },
        { name: 'closeDate', align: 'left', required: true, label: 'Close Date', field: 'closeDate', sortable: true, format: formatDate },
        { name: 'isOpen', align: 'left', required: true, label: 'Open Now', field: 'isOpen', sortable: true, format: val => val ? 'Open' : 'Closed' },
        { name: 'actions', align: 'center', required: true, label: 'Actions', field: '', sortable: false }
      ],
      pagination: {
        rowsPerPage: 0
      }
    }
  }
}
</script>
